"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _reactResponsive = require("react-responsive");

var _styledComponents = require("styled-components");

var _lodash = require("lodash");

var _About = _interopRequireDefault(require("./views/About"));

var _Gallery = _interopRequireDefault(require("./views/Gallery"));

var _Topnav = _interopRequireDefault(require("./components/Topnav"));

var _Footer = _interopRequireDefault(require("./components/Footer"));

var _FolderCarousel = _interopRequireDefault(require("./components/FolderCarousel"));

var _Contact = _interopRequireDefault(require("../../common/Contact"));

var _StyledLayout = require("../../../StyledLayout");

var _EmptyState = _interopRequireDefault(require("../../common/EmptyState"));

var _TermsOfUse = _interopRequireDefault(require("../../common/TermsOfUse"));

var _PrivacyPolicy = _interopRequireDefault(require("../../common/PrivacyPolicy"));

var _theme = require("../../../Themes/theme");

var _ScrollToTop = _interopRequireDefault(require("../../common/components/ScrollToTop"));

var _helpers = require("../../common/helpers");

var _constants = require("../../constants/constants");

var _Elements = require("./Elements");

require("slick-carousel/slick/slick.css");

require("slick-carousel/slick/slick-theme.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Adams = function Adams(_ref) {
  var _portfolio$folders, _portfolio$folders$fi, _portfolio$user, _portfolio$location, _portfolio$location2, _portfolio$user2, _portfolio$location3, _portfolio$termsOfUse, _portfolio$privacyPol;

  var portfolio = _ref.portfolio,
      onSubmitMessage = _ref.onSubmitMessage,
      type = _ref.type,
      webpSupported = _ref.webpSupported;
  var isTabletPortrait = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 768px)'
  });

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      sliderIndex = _useState2[0],
      setSliderIndex = _useState2[1];

  var _useState3 = (0, _react.useState)(window.innerHeight * 0.01),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      vh1 = _useState4[0],
      setVh1 = _useState4[1];

  var scrollBodyRef = (0, _react.useRef)(null);

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      canScroll = _useState6[0],
      setCanScroll = _useState6[1];

  var isTypeTheme = type === _constants.PORTFOLIO_THEME_TYPE.THEME;

  var _useRouteMatch = (0, _reactRouterDom.useRouteMatch)(),
      url = _useRouteMatch.url; // Exclude null and empty folders


  var folders = (portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$folders = portfolio.folders) === null || _portfolio$folders === void 0 ? void 0 : (_portfolio$folders$fi = _portfolio$folders.filter) === null || _portfolio$folders$fi === void 0 ? void 0 : _portfolio$folders$fi.call(_portfolio$folders, function (folder) {
    var _folder$photos, _folder$photos$edges;

    return folder && ((_folder$photos = folder.photos) === null || _folder$photos === void 0 ? void 0 : (_folder$photos$edges = _folder$photos.edges) === null || _folder$photos$edges === void 0 ? void 0 : _folder$photos$edges.length) > 0;
  })) || [];
  var publicUrl = url === '/' ? '' : url;
  var baseUrl = "".concat(portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$user = portfolio.user) === null || _portfolio$user === void 0 ? void 0 : _portfolio$user.username, ".").concat(process.env.REACT_APP_PORTFOLIO_HOST);
  var userLocationData = [portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$location = portfolio.location) === null || _portfolio$location === void 0 ? void 0 : _portfolio$location.city, portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$location2 = portfolio.location) === null || _portfolio$location2 === void 0 ? void 0 : _portfolio$location2.country];
  var location = userLocationData.filter(function (val) {
    return val;
  }).join(', ');
  var handleResize = (0, _lodash.debounce)(function () {
    setVh1(window.innerHeight * 0.01);
  }, 300); // eslint-disable-next-line consistent-return

  (0, _react.useEffect)(function () {
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  var tosUrl = (0, _helpers.generateTosUrl)(portfolio, publicUrl);
  var policyUrl = (0, _helpers.generatePolicyUrl)(portfolio, publicUrl);
  var coverPhotoUrl = (0, _helpers.getCoverPhotoUrl)(portfolio === null || portfolio === void 0 ? void 0 : portfolio.coverPhoto);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: (0, _theme.configPortfolioTheme)(portfolio.appearance.toLocaleLowerCase(), _constants.PORTFOLIO_THEME_FONTFAMILY[portfolio.font])
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.BrowserRouter, null, /*#__PURE__*/_react["default"].createElement(_ScrollToTop["default"], {
    ref: scrollBodyRef
  }), /*#__PURE__*/_react["default"].createElement(_Topnav["default"], {
    folders: folders,
    websiteName: portfolio.title,
    publicUrl: publicUrl,
    visibilityOptions: portfolio === null || portfolio === void 0 ? void 0 : portfolio.visibilityOptions,
    socialMedia: portfolio === null || portfolio === void 0 ? void 0 : portfolio.socialMedia,
    username: portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$user2 = portfolio.user) === null || _portfolio$user2 === void 0 ? void 0 : _portfolio$user2.username,
    colour: portfolio === null || portfolio === void 0 ? void 0 : portfolio.colour
  }), /*#__PURE__*/_react["default"].createElement(_Elements.AdamsBody, {
    ref: scrollBodyRef,
    isTabletPortrait: isTabletPortrait,
    isTypeTheme: isTypeTheme // Can always scroll on mobile
    ,
    canScroll: canScroll || !isTabletPortrait,
    vh1: vh1
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(publicUrl, "/about")
  }, /*#__PURE__*/_react["default"].createElement(_About["default"], {
    cover: coverPhotoUrl,
    description: portfolio.description,
    setCanScroll: setCanScroll,
    isTypeTheme: isTypeTheme,
    vh1: vh1,
    location: location,
    visibilityOptions: portfolio === null || portfolio === void 0 ? void 0 : portfolio.visibilityOptions
  })), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(publicUrl, "/contact")
  }, /*#__PURE__*/_react["default"].createElement(_Elements.ContactBox, null, /*#__PURE__*/_react["default"].createElement(_Contact["default"], {
    titleSize: "large",
    centerSendEmailBtn: true,
    isTypeTheme: isTypeTheme,
    colour: portfolio === null || portfolio === void 0 ? void 0 : portfolio.colour,
    setCanScroll: setCanScroll,
    onSubmitMessage: onSubmitMessage
  }))), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(publicUrl, "/gallery/:legacyId")
  }, /*#__PURE__*/_react["default"].createElement(_Gallery["default"], {
    publicUrl: publicUrl,
    folders: folders,
    colour: portfolio === null || portfolio === void 0 ? void 0 : portfolio.colour,
    isTypeTheme: isTypeTheme,
    vh1: vh1,
    webpSupported: webpSupported
  })), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(publicUrl, "/terms")
  }, /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    px: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_TermsOfUse["default"], {
    siteTitle: portfolio === null || portfolio === void 0 ? void 0 : portfolio.title,
    activeSiteUrl: baseUrl,
    userCountry: (portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$location3 = portfolio.location) === null || _portfolio$location3 === void 0 ? void 0 : _portfolio$location3.country) || 'Canada',
    setCanScroll: setCanScroll
  }))), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(publicUrl, "/policy")
  }, /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    px: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_PrivacyPolicy["default"], {
    siteTitle: portfolio === null || portfolio === void 0 ? void 0 : portfolio.title,
    setCanScroll: setCanScroll
  }))), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "".concat(publicUrl)
  }, folders.length === 0 ? /*#__PURE__*/_react["default"].createElement(_Elements.EmptyStateBox, {
    flex: true,
    align: "center",
    justify: "center"
  }, /*#__PURE__*/_react["default"].createElement(_EmptyState["default"], {
    site: portfolio.title
  })) : /*#__PURE__*/_react["default"].createElement(_FolderCarousel["default"], {
    portfolio: portfolio,
    folders: folders,
    isTabletPortrait: isTabletPortrait,
    isTypeTheme: isTypeTheme,
    vh1: vh1,
    sliderIndex: sliderIndex,
    setSliderIndex: setSliderIndex,
    webpSupported: webpSupported,
    publicUrl: publicUrl
  })))), /*#__PURE__*/_react["default"].createElement(_Footer["default"], {
    name: portfolio.title,
    publicUrl: publicUrl,
    tosUrl: tosUrl,
    policyUrl: policyUrl,
    colour: portfolio === null || portfolio === void 0 ? void 0 : portfolio.colour,
    isCustomTos: !!(portfolio !== null && portfolio !== void 0 && (_portfolio$termsOfUse = portfolio.termsOfUse) !== null && _portfolio$termsOfUse !== void 0 && _portfolio$termsOfUse.url),
    isCustomPolicy: !!(portfolio !== null && portfolio !== void 0 && (_portfolio$privacyPol = portfolio.privacyPolicy) !== null && _portfolio$privacyPol !== void 0 && _portfolio$privacyPol.url)
  })));
};

Adams.defaultProps = {
  onSubmitMessage: function onSubmitMessage() {},
  webpSupported: false
};
Adams.propTypes = {
  portfolio: _propTypes["default"].shape({
    title: _propTypes["default"].string,
    status: _propTypes["default"].oneOf(['ONBOARDING', 'ACTIVE', 'INACTIVE']),
    description: _propTypes["default"].string,
    appearance: _propTypes["default"].string,
    font: _propTypes["default"].string,
    folders: _propTypes["default"].arrayOf(_propTypes["default"].shape()),
    colour: _propTypes["default"].string,
    coverPhoto: _propTypes["default"].shape({
      photo: _propTypes["default"].shape({
        images: _propTypes["default"].arrayOf(_propTypes["default"].shape())
      })
    }),
    location: _propTypes["default"].shape({
      country: _propTypes["default"].string,
      city: _propTypes["default"].string
    }),
    socialMedia: _propTypes["default"].shape({
      instagram: _propTypes["default"].string,
      facebook: _propTypes["default"].string,
      twitter: _propTypes["default"].string
    }),
    user: _propTypes["default"].shape({
      username: _propTypes["default"].string
    }),
    visibilityOptions: _propTypes["default"].shape({
      pxProfile: _propTypes["default"].string
    }),
    termsOfUse: _propTypes["default"].shape({
      url: _propTypes["default"].string
    }),
    privacyPolicy: _propTypes["default"].shape({
      url: _propTypes["default"].string
    })
  }).isRequired,
  onSubmitMessage: _propTypes["default"].func,
  type: _propTypes["default"].string.isRequired,
  webpSupported: _propTypes["default"].bool
};
var _default = Adams;
exports["default"] = _default;